<template>
  <v-dialog
    v-model="computedDialogUiWatermap"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-card tile>
      <v-toolbar card>
        <v-btn icon @click.native="methodDialogUi('watermap')">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Snowmaking watermap</v-toolbar-title>
      </v-toolbar>
      <iframe
        v-if="computedDialogUiWatermap"
        :src="watermapUrl()"
        height="100%"
      />
      <div style="flex: 1 1 auto;"></div>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      build_timestamp: process.env.VUE_APP_BUILD_NUM
    };
  },
  computed: {
    computedDialogUiWatermap() {
      return this.$store.state.ui.dialogs.watermap;
    },
    computedGeneral() {
      return this.$store.state.general;
    },
    computedAuth() {
      return this.$store.state.auth;
    }
  },
  methods: {
    watermapUrl() {
      let dept;
      if (
        this.computedAuth.profile["https://gis.wbsnowmaking.com/app_metadata"]
          .department
      ) {
        dept = this.computedAuth.profile[
          "https://gis.wbsnowmaking.com/app_metadata"
        ].department[0];
      } else {
        dept = "no_dept";
      }
      return `watermap.html?user=${this.computedAuth.profile.email}&dept=${dept}&roles=${this.computedAuth.profile["https://gis.wbsnowmaking.com/app_metadata"].roles[0]}`;
    },
    methodDialogUi(dialog) {
      this.$store.commit("mutationDialogUi", {
        dialog: dialog
      });
    }
  }
};
</script>
